'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { removeNotification } from '../actions/NotificationActions';

class NotificationList extends Component {
  render() {
    const {
      className,
      notifications,
      onRemoveNotification
    } = this.props;
    const floatingAlerts = Object.keys(notifications).map(notificationId => {
      const clonedNotification = Object.assign({}, notifications[notificationId]); // These properties are only used internally by ReduxMessenger,
      // and should not be passed onto the UIFloatingAlert component

      delete clonedNotification.sticky;
      delete clonedNotification.timeout;
      return clonedNotification;
    });
    return /*#__PURE__*/_jsx(UIFloatingAlertList, {
      alerts: floatingAlerts,
      className: className,
      onAlertClose: (evt, {
        id
      }) => onRemoveNotification(id)
    });
  }

}

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.object.isRequired,
  onRemoveNotification: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  notifications: state.notifications
});

const actionCreators = {
  onRemoveNotification: removeNotification
};
export default connect(mapStateToProps, actionCreators)(NotificationList);